import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: "Scouting",
};

export const scoutingActiveTabSlice = createSlice({
  name: "scoutingTab",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setActiveTab } = scoutingActiveTabSlice.actions;

export default scoutingActiveTabSlice.reducer;
